<template>
<div class="div_sec">

  <el-row :gutter="60">
    <el-col :span="24" class="card-01">
      <el-row>
        <el-col :span="21" class="modal_title middle_blue">Diagnóza/událost
        </el-col>
         <el-col :span="21"> <span class="modal_title green small">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
        </el-col>
        <el-col :span="3">
          <el-button :disabled="!loginuser.editor" class="btn-green" icon="el-icon-plus" size="small" @click="examination_new"> Nová diagnóza/událost</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-table
            ref="exams_table"
            :data="examinations"
            style="width: 100%; word-break: normal;"
            row-key="id_examination"
            v-loading="loading_examinations"
            element-loading-text="Loading..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(211, 227, 218, 0.8)"
            :default-sort="{prop:'id_examination', order:'ascending'}"
            border
            highlight-current-row
            @sort-change="SortChange_examinations"
            :stripe="true"
          >
            <el-table-column
              prop="id_examination"
              label="ID D/U"
              width="150"
              sortable>
            </el-table-column>
            <el-table-column
              prop="status"
              label="Status"
              width="150"
              sortable="custom">
            </el-table-column>
            <el-table-column
              prop="started"
              label="Začátek"
              width="200"
              sortable>
            </el-table-column>
            <el-table-column
              prop="finished"
              label="Konec"
              width="200"
              sortable>
            </el-table-column>
            <el-table-column
              prop="d_name"
              label="Diagnóza"
              min-width=""
              sortable="custom">
            </el-table-column>
            <el-table-column
              width="380"
              fixed="right"
              label="Akce"
              align="right"
              >
              <template slot-scope="props">
                <el-button-group>
                  <el-button :disabled="!loginuser.editor" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="operation_new( props.$index, props.row, $event )">Operace</el-button>
                  <el-button :disabled="!loginuser.editor" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="checkup_new( props.$index, props.row, $event )">Kontrola</el-button>
                  <el-button :disabled="!loginuser.editor" class="btn-blue-mid" size="mini" icon="el-icon-plus" @click="medication_new( props.$index, props.row, $event )">Léčba</el-button>
                  <el-button class="btn-grey-lit" size="mini" icon="el-icon-view" @click="examination_show( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="examination_edit( props.$index, props.row, $event )"></el-button>
                  <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="examination_delete( props.$index, props.row, $event )"></el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-col>
  </el-row>

</div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  let notifier = new Vue();

  export default {
    computed: {
      ...mapState({
        loginuser: state => state.loginuser,

        examinations: state => state.examinations,
        examination: state => state.examination,
        sorting_examinations: state => state.sorting_examinations,
        loading_examinations: state => state.loading_examinations,

        patient: state => state.patient,
        operation: state => state.operation,
        medication: state => state.medication,
        checkup: state => state.checkup,

        l_exam_cis_sk_nadoru: state => state.l_exam_cis_sk_nadoru,

        modal_examination_ro: state => state.modal_examination_ro,

      }),

      ...mapGetters({

      }),

    },


    data () {
      return {

      }
    },

    methods: {
      ...mapMutations({
        m_modal_examination: 'm_modal_examination',
        m_modal_examination_ro: 'm_modal_examination_ro',
        m_examination_by_key: 'm_examination_by_key',
        m_examination_reset: 'm_examination_reset',

        m_operation_reset: 'm_operation_reset',
        m_modal_operation: 'm_modal_operation',
        m_modal_operation_ro: 'm_modal_operation_ro',

        m_checkup_reset: 'm_checkup_reset',
        m_modal_checkup: 'm_modal_checkup',
        m_modal_checkup_ro: 'm_modal_checkup_ro',

        m_medication_reset: 'm_medication_reset',
        m_modal_medication: 'm_modal_medication',
        m_modal_medication_ro: 'm_modal_medication_ro',
      }),


      ...mapActions({
        a_examination: 'a_examination',
        a_examinations: 'a_examinations',
        a_examination_delete: 'a_examination_delete',

        a_med_cis_bio_ter_lek: 'a_med_cis_bio_ter_lek',
        a_med_cis_protokol: 'a_med_cis_protokol',
        a_med_cis_chem_int_cyt: 'a_med_cis_chem_int_cyt',
        a_med_cis_chem_int_inthe_inver_cyt: 'a_med_cis_chem_int_inthe_inver_cyt',
        a_med_cis_udr_chem_inthe_inver_cyt: 'a_med_cis_udr_chem_inthe_inver_cyt',
        a_exam_cis_sk_nadoru_get: 'a_exam_cis_sk_nadoru_get',

      }),


      examination_new() {
        this.m_modal_examination_ro(false);
        this.m_examination_reset();
        this.examination.id_patient = this.patient.id_patient;
        this.a_exam_cis_sk_nadoru_get();
        this.m_modal_examination(true);
      },

      examination_show (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_examination_ro(true);
        this.m_examination_reset();
        this.examination.id_examination = row.id_examination;
        this.a_examination( {'id_examination': row.id_examination} );
        this.a_exam_cis_sk_nadoru_get();
        this.m_modal_examination(true);
      },


      examination_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_examination_ro(false);
        this.m_examination_reset();
        this.examination.id_examination = row.id_examination;
        this.a_examination( {'id_examination': row.id_examination} );
        this.a_exam_cis_sk_nadoru_get();
        this.m_modal_examination(true);
      },


      examination_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.$confirm(`Opravdu chcete položku smazat?`, 'Upozornění', {
          confirmButtonText: 'ANO',
          cancelButtonText: 'NE',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.a_examination_delete( {'id_examination': row.id_examination} );
          this.a_examinations( {} );
          // this.$message({ type: 'success', message: 'Diagnóza/událost byla smazána.' });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Smazání položky přerušeno.'
          });
        });

      },


      operation_new(index, row, event) {
        this.m_modal_operation_ro(false);
        this.m_operation_reset();
        this.operation.id_patient = this.patient.id_patient;
        this.operation.id_examination = row.id_examination;
        this.m_modal_operation(true);
      },


      checkup_new(index, row, event) {
        this.m_modal_checkup_ro(false);
        this.m_checkup_reset();
        this.checkup.id_patient = this.patient.id_patient;
        this.checkup.id_examination = row.id_examination;
        this.m_modal_checkup(true);
      },


      medication_new(index, row, event) {
        this.m_modal_medication_ro(false);
        this.m_medication_reset();
        this.a_med_cis_bio_ter_lek();
        this.a_med_cis_protokol();
        this.a_med_cis_chem_int_cyt();
        this.a_med_cis_chem_int_inthe_inver_cyt();
        this.a_med_cis_udr_chem_inthe_inver_cyt();
        this.medication.id_patient = this.patient.id_patient;
        this.medication.id_examination = row.id_examination;
        this.m_modal_medication(true);
      },


      SortChange_examinations(val) {
        this.sorting_examinations.sorting_prop = val.prop;
        this.sorting_examinations.sorting_ordering = val.order;
        this.a_examinations();
      },


      handleChange(value) {
        console.log(value);
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },

    },

    beforeMount () {
    },

    created () {
    },

    mounted () {

    },

    beforeDestroy () {
    },


  }
</script>

<style lang="scss" scoped>

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}

.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}

.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

.el-select .el-input {
  width: 220px !important;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item {
   margin-bottom: 0 !important;
  }

.el-select {
  padding: 0 20px 10px 0 !important;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #7b8d9f;
    cursor: not-allowed;
}

</style>

